export class BankDetails {
  title: string;
  address: string[];
  id: string;
  type: string;
  addBottomPadding: boolean;
  bankSubDetailsArray: BankSubDetails[];
}

export class BankSubDetails {
  title: string;
  data: string;
  id: string;
  addBottomPadding: boolean;
}
